import IconInfo from '@/assets/IconInfo.svg';
import IconRegister from '@/assets/IconRegister.svg';
import React from 'react';

import useApi from '@/hooks/useApi';
import { useVitrineTagging } from '@/hooks/useVitrineTagging';
import { IEventsTag } from '@/hooks/useVitrineTagging/types';

import { Header } from '@/components/global/Header';
import { RegisteredLabel } from '@/components/Template/Template3/RegisteredLabel';
import { FixedCard } from '@/components/Template/Template3/Slider/FixedCard';

import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import {
  TInteractionButtonSendClick,
  TInteractionMoreInfo,
} from '@/services/requests/Interactions/types';
import {
  TCard,
  TRecommendation,
} from '@/services/requests/Recommendation/types/template3';

import { getValue } from '@/helpers/GetValueHelper';

type TProps = {
  data: TRecommendation;
};

export function Layout1({ data }: TProps) {
  const { Api, traceId } = useApi();

  const { triggerSelectContentClick } = useVitrineTagging({
    events_tag: data.events_tag as IEventsTag,
    title: data.title,
  });

  function handlerRegister() {
    dispatchInteraction<TInteractionButtonSendClick>(Api, 'button-send', {
      recommendationId: data.id,
      cards: [getValue(data, 'fixed_card.id', '') as string],
      tabName: '',
    });

    const optinIdLiferay = data.params.find(item => item.name.includes('id'));

    const detail = {
      id: getValue(optinIdLiferay, 'value', '') as string,
      traceId,
      recommendationId: data.id,
    };

    const event = new CustomEvent('smls-optin-open', {
      detail,
    });

    window.dispatchEvent(event);
  }

  async function handleMoreInfo() {
    triggerSelectContentClick({
      type: 'button',
      current: getValue(data, 'more_info.label', 'Mais informações'),
    });

    await dispatchInteraction<TInteractionMoreInfo>(Api, 'more-info', {
      recommendationId: data.id,
      cards: [getValue(data, 'fixed_card.id', '') as string],
    });

    const link = getValue(data, 'more_info.link', '');
    window.location.assign(link);
  }

  const handleCardClick = () => {
    triggerSelectContentClick({
      type: 'card',
      current: data?.fixed_card?.title || '',
    });
  };

  return (
    <>
      <Header data={data.header} template="3" />
      <FixedCard
        data={getValue(data, 'fixed_card', {}) as TCard}
        onClick={handleCardClick}
      />
      {!data.registered_label && (
        <button
          type="button"
          className="vitrine-template3__button"
          onClick={handlerRegister}
        >
          <img
            src={IconRegister}
            alt={getValue(data, 'cta.label', 'Quero me cadastrar')}
          />
          {getValue(data, 'cta.label', 'Quero me cadastrar')}
        </button>
      )}
      <button
        type="button"
        className="vitrine-template3__more-info"
        onClick={handleMoreInfo}
      >
        <img
          src={IconInfo}
          alt={getValue(data, 'more_info.label', 'Mais informações')}
        />
        {getValue(data, 'more_info.label', 'Mais informações')}
      </button>
      <RegisteredLabel
        label={data.registered_label}
        className="vitrine-template3__registered-label"
      />
    </>
  );
}
